// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"02c8e304","791":"cbec0456","822":"ee393f62"}[chunkId] + ".chunk.css";
};